module.exports = __webpack_public_path__ + "img/loading.cce83c14.gif";